import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
    busAcc: {} // 线下对公账号查询接口
  },

  mutations: {
    setBusAcc (state, data) {
      state.busAcc = data
    }
  },

  actions: {

    // 线下还款对公账户查询
    async getBusAccX ({ commit }, params) {
      const response = await axios.post('/repay/v1/offline/getBusAcc', params)
      if (response.success === true) {
        commit('setBusAcc', response.data)
      }
      return response.data
    },

    // 查询还款试算接口
    async getRepayTrialX ({ commit }, params) {
      const response = await axios.post('/repay/v1/trial', params)
      return response.data
    },
    // 还款状态查询
    async getRepayStatusX ({ commit }, params) {
      const response = await axios.post('/repay/v1/query', params)
      return response.data
    },

    // 还款申请
    async repayApplyX ({ commit }, params) {
      const response = await axios.post('/repay/v1/apply', params)
      return response.data
    },
    // 协商还款新借据信息查询
    async consult ({ commit }, params) {
      const response = await axios.post('/order/v1/consult', params)
      return response.data
    },
    // 协商还款借款申请预览
    async consultPreview ({ commit }, params) {
      const response = await axios.post('/consult/repayment/v1/preview', params)
      return response.data
    },
    // 协商还款借款申请
    async consultApply ({ commit }, params) {
      const response = await axios.post('/consult/repayment/v1/apply', params)
      return response.data
    },
    // 协商还款借款确认
    async consultConfirm ({ commit }, params) {
      const response = await axios.post('/consult/repayment/v1/confirm', params)
      return response.data
    },
    // 协商还款借款结果查询
    async consultResult ({ commit }, params) {
      const response = await axios.post('/consult/repayment/v1/result', params)
      return response.data
    },
    // 协商还款要素，如最早借款时间，最晚借款时间
    async queryElement ({ commit }, params) {
      const response = await axios.post('/consult/repayment/v1/element', params)
      return response.data
    },
    // 还款中-会员banner
    async repayResultBanner ({ commit }, params) {
      const response = await axios.get('/loan/v1/repay-result', params)
      return response.data
    },
    // - 借款详情-可还-引导购卡弹窗
    async svipLoanPopup ({ commit }, params) {
      const response = await axios.get('/svip/v1/svip-loan-popup', { method: 'get', params })
      return response.data
    },
    // 消费账单还款试算
    async consumptionRepayTrialX ({ commit }, params) {
      const response = await axios.post('/repay/v1/consumptionRepayTrial', params)
      return response.data
    },
    // 消费账单还款申请
    async consumptionRepayApplyX ({ commit }, params) {
      const response = await axios.post('/repay/v1/consumptionRepayApply', params)
      return response.data
    },
    // 消费账单还款详情
    async consumptionRepayQueryX ({ commit }, params) {
      const response = await axios.post('/repay/v1/consumptionRepayQuery', params)
      return response.data
    }
  }
}
